export default "__VITE_PUBLIC_ASSET__08e49eab__"